import { createAsyncThunk } from '@reduxjs/toolkit';
import CommonEnumsResource from 'api/service/CommonEnumsResource';

export const listSalesMethods = createAsyncThunk('properties/listSalesMethods', async () => {
  const commonEnumsResource = new CommonEnumsResource();
  const { status, data } = await commonEnumsResource.list('property_sales_method');
  if (status === 200) {
    return data;
  }
  return [];
});
